import { TMBoardId, TMChangeOrderBoardResponse } from '@business/entities/tm/TMChangeOrderBoardResponse';
import { Endpoint } from '../endpoint';
import { R } from '@core/utils/r';
import { TimeMaterialsFilterData } from '@modules/timeMaterials/TimeMaterialsPage/TimeMaterialsPage';
import { TimeMaterialBoardResponse } from '@business/entities/tm/TimeMaterialBoardResponse';

export function fetchStatuses(permission = true) {
  return Endpoint.get<TMChangeOrderBoardResponse[]>(`@gc/tm-rma-damage-status`, { params: { permission } });
}

export function fetchStatus(id: TMBoardId, data?: Partial<TimeMaterialsFilterData>) {
  const params = R.objectCompact(data);
  return Endpoint.get<TMChangeOrderBoardResponse>(`@gc/tm-rma-damage-status/board/${id}`, { params });
}

export function createStatus(data: Partial<TMChangeOrderBoardResponse> | Partial<TimeMaterialBoardResponse>) {
  return Endpoint.post<TMChangeOrderBoardResponse>(`@gc/tm-rma-damage-status`, { data });
}

export function updateStatus(id: string, data: Partial<TMChangeOrderBoardResponse> | Partial<TimeMaterialBoardResponse>) {
  return Endpoint.patch<TMChangeOrderBoardResponse>(`@gc/tm-rma-damage-status/${id}`, { data });
}

export function deleteStatus(id: string) {
  return Endpoint.delete<void>(`@gc/tm-rma-damage-status/${id}`);
}
